import { z } from 'zod';
/**
 * Query params del listado `GET /api/obras`.
 *
 *  - `q`: substring sobre works_no o display_name (case-insensitive).
 *  - `solo_activas`: si true (default), filtra por status='Open' (~60 obras).
 *    Si false, devuelve todas (~192).
 *  - `limite`: máx filas (default 200, máx 500). Pensado para combobox.
 */
export const ListarObrasRequestSchema = z.object({
    q: z.string().min(1).max(100).optional(),
    solo_activas: z
        .union([z.boolean(), z.literal('true'), z.literal('false')])
        .transform((v) => v === true || v === 'true')
        .optional(),
    limite: z.coerce.number().int().min(1).max(500).default(200),
});
/**
 * Asignar/cambiar/quitar obra. `obra_works_no = null` quita la obra.
 */
export const AsignarObraRequestSchema = z.object({
    obra_works_no: z.string().trim().min(1).max(20).nullable(),
});
//# sourceMappingURL=obras.js.map